import React from "react";
import { Edit, SimpleForm, TextInput, SelectInput, required } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { Typography } from "@mui/material";
import { editTitle } from "../../../customStyles/ra-custom-styles";
import { auctionType } from "../../../utils/options";
import { languageChoices } from "../../../utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const EditAuctions = () => {
  return (
    <Edit
      title="Търгове - наеми/продажби"
      mutationMode="pessimistic"
      sx={editTitle}
    >
      <Typography sx={editTitle}>Редакция на търг (наеми / продажби)</Typography>
      <SimpleForm>
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <TextInput
          label="Заглавие"
          source="title"
          fullWidth
        />
        <CustomDateInput
          label="Дата"
          source="starting_on"
          validate={required()}
        />

        <SelectInput
          choices={auctionType}
          label="Вид"
          source="auction_type"
          validate={required()}
        />
        <RichTextInput
          label="Съобщение"
          source="content"
          validate={required()}
          multiline
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
};

export default EditAuctions;
